import { CompanyCollectorResponseDto } from '@domain/company-collector/dtos/company-collector.response.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CompanyCollectorModel } from '../models/company-collector.model';
import { PaymentCollectorModel } from '@domain/payment-collector/models/payment-collector.model';
import { OrganizationCompanyModel } from '@domain/organization-company/models/organization-company.model';
import { UserPersonModel } from '@domain/user-person/models/user-person.model';

export class CompanyCollectorMapper {
  mapDtoToModel(response: CompanyCollectorResponseDto): CompanyCollectorModel {
    return new CompanyCollectorModel({
      refId: response.refId,
      paymentCollector: response.paymentCollector
        ? new PaymentCollectorModel({ ...response.paymentCollector })
        : undefined,
      organizationCompany: response.organizationCompany
        ? new OrganizationCompanyModel({
            ...response.organizationCompany,
            createdBy: response.organizationCompany.createdBy
              ? new UserPersonModel({
                  ...response.organizationCompany.createdBy,
                })
              : undefined,
          })
        : undefined,
      state: response.state,
      commissionRules: response.commissionRules,
      createdAt: response.createdAt,
      updatedAt: response.updatedAt,
    });
  }

  mapPageableDtoToModel(
    response: PageableResponse<CompanyCollectorResponseDto>,
  ): PageableResponse<CompanyCollectorModel> {
    const {
      content,
      empty,
      first,
      last,
      number,
      numberOfElements,
      totalElements,
      totalPages,
    } = response;

    const mappedContent = content.map((item) => this.mapDtoToModel(item));

    return {
      content: mappedContent,
      empty,
      first,
      last,
      number,
      numberOfElements,
      totalElements,
      totalPages,
    };
  }
}
